module.exports = __webpack_public_path__ + "static/img/7.6bbb70e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hhwhyx/7.jpg
// module id = /mtg
// module chunks = 1